import {WarningMessageDefaultBox} from "./warning-message.default.box";

export const WarningMessageBox = WarningMessageDefaultBox;